import type { GetStaticPaths, GetStaticProps } from 'next';

import { makeArticlePage } from '../../../modules/energy-insights/articles/article-page';
import {
  makeArticlePageStaticPropsRequest,
  makeStaticPathsRequest,
} from '../../../modules/energy-insights/articles/get-static-props';
import type { IArticlePageProps, UrlParams } from '../../../modules/energy-insights/articles/types';

const ArticlePage = makeArticlePage();
export default ArticlePage;

export const getStaticProps: GetStaticProps<IArticlePageProps, UrlParams> = ({ params, preview }) =>
  makeArticlePageStaticPropsRequest(params.slug, 'Article not found', preview);

export const getStaticPaths: GetStaticPaths<UrlParams> = () => makeStaticPathsRequest();
